import * as i0 from '@angular/core';
import * as i1 from './menu-bar.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/router';
import * as i4 from '../common/auto-focus.directive';
import * as i5 from '../common/template-loader.component';
import * as i6 from '../common/resizeable.directive';
import * as i7 from '../common/dropdown.directive';
import * as i8 from './menu-bar.component';
import * as i9 from './nav-item.component';
import * as i10 from '../common/trust-html.pipe';
import * as i11 from '../common/date.pipe';
import * as i12 from '../common/common.module';
export const MenuBarModuleNgFactory:i0.NgModuleFactory<i1.MenuBarModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.RouterOutlet = (<any>(null as any));
var _decl0_12:i3.RouterLink = (<any>(null as any));
var _decl0_13:i3.RouterLinkWithHref = (<any>(null as any));
var _decl0_14:i3.RouterLinkActive = (<any>(null as any));
var _decl0_15:i3.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_16:i4.AutoFocusDirective = (<any>(null as any));
var _decl0_17:i5.TemplateLoaderComponent = (<any>(null as any));
var _decl0_18:i6.ResizeableDirective = (<any>(null as any));
var _decl0_19:i7.DropdownDirective = (<any>(null as any));
var _decl0_20:i8.MenuBarComponent = (<any>(null as any));
var _decl0_21:i9.NavItemComponent = (<any>(null as any));
var _decl0_22:i2.AsyncPipe = (<any>(null as any));
var _decl0_23:i2.UpperCasePipe = (<any>(null as any));
var _decl0_24:i2.LowerCasePipe = (<any>(null as any));
var _decl0_25:i2.JsonPipe = (<any>(null as any));
var _decl0_26:i2.SlicePipe = (<any>(null as any));
var _decl0_27:i2.DecimalPipe = (<any>(null as any));
var _decl0_28:i2.PercentPipe = (<any>(null as any));
var _decl0_29:i2.TitleCasePipe = (<any>(null as any));
var _decl0_30:i2.CurrencyPipe = (<any>(null as any));
var _decl0_31:i2.DatePipe = (<any>(null as any));
var _decl0_32:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_33:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_34:i2.KeyValuePipe = (<any>(null as any));
var _decl0_35:i10.TrustHtmlPipe = (<any>(null as any));
var _decl0_36:i11.DatePipe = (<any>(null as any));
var _decl0_37:i2.CommonModule = (<any>(null as any));
var _decl0_38:i3.RouterModule = (<any>(null as any));
var _decl0_39:i12.RebirthCommonModule = (<any>(null as any));
var _decl0_40:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_41:i0.ElementRef<any> = (<any>(null as any));
function _View_MenuBarComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_MenuBarComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(3,'menu-bar navbar navbar-',(_decl0_20.inverse? 'inverse': 'default'),
      ' ',_decl0_20.type,' ',_decl0_20.cssClass,'');
  currVal_0;
  const currVal_1:any = (<any>{'sidebar-open':_decl0_20.sidebarOpen});
  currVal_1;
  const currVal_2:any = i0.ɵinlineInterpolate(1,'',((_decl0_20.type == 'sidebar')? 'container-fluid': _decl0_20.contentType),
      '');
  currVal_2;
  const currVal_3:any = (_decl0_20.menuOptions.logo || _decl0_20.menuOptions.title);
  currVal_3;
  const currVal_4:any = 'navbar-collapse';
  currVal_4;
  const currVal_5:any = (<any>{collapse:!_decl0_20.showNavBar,in:_decl0_20.showNavBar});
  currVal_5;
  const currVal_6:any = _decl0_20.menuOptions.menus;
  currVal_6;
  const currVal_7:any = _decl0_20.direction;
  currVal_7;
  const currVal_8:any = _decl0_20.menuOptions.rightMenus;
  currVal_8;
  const currVal_9:any = true;
  currVal_9;
  const currVal_10:any = _decl0_20.direction;
  currVal_10;
  const pd_11:any = ((<any>_decl0_20.hide(_any)) !== false);
}
function _View_NavItemComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_NavItemComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'nav navbar-nav';
  currVal_0;
  const currVal_1:any = (<any>{'navbar-right':_decl0_21.right});
  currVal_1;
  const currVal_2:any = _decl0_21.menus;
  currVal_2;
}
